// @charset "utf-8";
import feedbackComponent from '@/components/lib/feedback'

const feedBack = {
    install: function (Vue) {
        Vue.component('feedBack', feedbackComponent)
    }
}

export default feedBack



// WEBPACK FOOTER //
// ./src/lib/feedback.js